/* eslint-disable */
import './static/loadFonts.css';
import './static/prism.css';
import 'lazysizes';

import { registerLinkResolver } from 'gatsby-source-prismic-graphql';

import init from './src/util/tracking';
import { linkResolver } from './src/util/linkResolver';

registerLinkResolver(linkResolver);

export const onInitialClientRender = () => {
  window.cookieDomain = '.digitalocean.com';
  window.googleMapsApiKey = 'AIzaSyCSKmGpLScyml6i3_YOoKoE7UCUeYs-H0k';

  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l != 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-KHWBBT');
  
  init();
};

export const onRouteUpdate = () => {
  window.analytics && window.analytics.page();
  window.dataLayer && window.dataLayer.push({
    event: 'pageviewCuttlefish',
    pagePath: `${window.location.pathname}`,
    pageTitle : `${window.document.title}`,
  });
};